import { render, staticRenderFns } from "./DHPlayer.vue?vue&type=template&id=acfb8336"
import script from "./DHPlayer.vue?vue&type=script&lang=js"
export * from "./DHPlayer.vue?vue&type=script&lang=js"
import style0 from "./DHPlayer.vue?vue&type=style&index=0&id=acfb8336&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports